import React from 'react';
const navigation = [{
  name: 'El video',
  href: '/#vsl'
}, {
  name: 'Diagnóstico gratuito',
  href: '/#calificar'
}, {
  name: 'Resultados de clientes',
  href: '/#resultados'
}];
export function Footer() {
  return <footer className="bg-ink-900 pt-16 pb-28 md:pb-12 border-t border-white/10 px-4 sm:px-6 lg:px-8" data-id="element-11" data-mp="32lrkxa44arie">
      <div className="max-w-7xl mx-auto" data-id="element-12" data-mp="36nd6rkymqg4q">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 pb-12" data-id="element-13" data-mp="3uesb1j9yv7im">
          {/* Brand */}
          <div className="md:col-span-5" data-id="element-14" data-mp="38z6mkvj6mzq">
            <div className="inline-flex flex-col items-center leading-none mb-5" data-id="element-15" data-mp="36mtqm4mr2tj">
              <span className="text-xl font-normal tracking-[0.4em] text-white pl-[0.4em]" data-id="element-16" data-mp="3ldu2qoshwdu8">
                VANTIX
              </span>
              <span className="text-[9px] font-medium tracking-[0.3em] text-white/80 border-t border-gold pt-1.5 mt-1.5 w-full text-center pl-[0.3em]" data-id="element-17" data-mp="29z6t68jqcdeb">
                CREDIT SOLUTIONS
              </span>
            </div>
            <p className="text-white/70 font-normal leading-relaxed text-sm max-w-sm" data-id="element-18" data-mp="3l90mnssh4sxo">
              Restauramos perfiles de crédito y estructuramos el acceso a
              financiamiento personal y empresarial en Estados Unidos y Puerto
              Rico.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3" data-id="element-19" data-mp="3q7lr64erdyrx">
            <h2 className="text-[11px] font-semibold tracking-[0.18em] uppercase text-white/40 mb-4" data-id="element-20" data-mp="3qazrl73v3xwq">
              Navegación
            </h2>
            <ul className="space-y-2.5" data-id="element-21" data-mp="34p6x15ihif3">
              {navigation.map(item => <li key={item.name} data-id="element-22" data-mp="htczqznz3e1c">
                  <a href={item.href} className="text-sm text-white/75 hover:text-white transition-colors" data-id="element-23" data-mp="hsadj51lhzrr">
                    {item.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4" data-id="element-24" data-mp="mptp1x6wryg0">
            <h2 className="text-[11px] font-semibold tracking-[0.18em] uppercase text-white/40 mb-4" data-id="element-25" data-mp="tvmpjfil4cku">
              Contacto
            </h2>
            <ul className="space-y-2.5" data-id="element-26" data-mp="yupii1laiscg">
              <li data-id="element-27" data-mp="13tke644cwbdz">
                <a href="tel:+14073678672" className="text-sm text-white/75 hover:text-white transition-colors" data-id="element-28" data-mp="13t0uoiz25exu">
                  +1 (407) 367-8672
                </a>
              </li>
              <li data-id="element-29" data-mp="1clcl44u692dt">
                <a href="mailto:eduardo@vantixcreditsolutions.com" className="text-sm text-white/75 hover:text-white transition-colors" data-id="element-30" data-mp="1cnypxwpoh3sc">
                  eduardo@vantixcreditsolutions.com
                </a>
              </li>
              <li className="text-sm text-white/70" data-id="element-31" data-mp="1ri3kwf7rcg3y">
                Servicio 100% remoto · Lunes a viernes
              </li>
            </ul>
          </div>
        </div>

        {/* Disclosure */}
        <div className="pt-8 border-t border-white/10" data-id="element-32" data-mp="3tai036ix36go">
          <p className="text-xs leading-relaxed text-white/55 max-w-3xl" data-id="element-33" data-mp="2afdidco5p8os">
            Vantix Credit Solutions no es un bufete de abogados ni una agencia
            de reporte crediticio. Los resultados varían según el perfil de cada
            cliente y no están garantizados salvo lo establecido por escrito en
            el contrato de servicio. Usted tiene derecho a disputar información
            inexacta en su reporte de crédito por su cuenta y sin costo alguno.
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-white/35" data-id="element-34" data-mp="2pc4mfz8rz8kq">
          <p data-id="element-35" data-mp="2kf4flm43q1sk">
            © {new Date().getFullYear()} Vantix Credit Solutions. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-36" data-mp="18yee2gamhy5a">
            <a href="/privacidad" className="hover:text-white/70 transition-colors" data-id="element-37" data-mp="18zftewyo96st">
              Privacidad
            </a>
            <a href="/terminos" className="hover:text-white/70 transition-colors" data-id="element-38" data-mp="2ruoi1bhm6u1j">
              Términos
            </a>
          </div>
        </div>
      </div>
    </footer>;
}